import styled from 'styled-components';
import React from 'react';

import { checkedIcon, copyIcon } from '../../../img';

export const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 482px;
  width: 482px;
  max-height: calc(100vh - 151px);
  margin: 25px 10px 0 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 15px;
  gap: 16px;

  & > div {
    overflow: unset;
    margin: 0px;
  }

  & .content {
    padding: 12px 20px 12px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    gap: 16px;

    &.keys-block {
      flex-direction: row;

      & .row {
        width: calc(50% - 8px);
      }
    }

    & .row {
      display: flex;
      align-items: center;

      & .label {
        font-size: 10px;
        font-weight: bold;
        color: rgb(103, 123, 139);
        min-width: 130px;
      }
      & .value {
        font-size: 14px;
        font-weight: 600;
        color: rgb(40, 40, 58);
      }
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const CheckedIcon = styled.div`
  display: flex;
  padding: 0;
  margin-left: auto;
  margin-right: -19px;
  width: 25px;
  height: 25px;
  background-image: url(${checkedIcon});
  background-repeat: no-repeat;
`;

export const CopyBtn = styled((props) => <img {...props} src={copyIcon} alt='' />)`
  cursor: pointer;
  max-width: 18px;
  max-height: 18px;
  position: absolute;
  right: 0px;
  bottom: 0px;
  padding: 8px;
`;

export const ImptyIcon = styled.div`
  width: 25px;
  height: 25px;
`;

export const CreateClientWrapper = styled.div`
  min-width: 356px;
  display: flex;
  flex-direction: column;

  & > .body {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 24px;
    margin: 24px 0 0;
    & .row {
      font-size: 10px;
      cursor: pointer;
      margin-bottom: 6px;
      & .check {
        & > div {
          margin: 0px;
          border: 1px solid rgba(40, 56, 144, 0.1);
          border-radius: 6px;
        }
        display: flex;
        align-items: center;
        font-size: 14px;
        gap: 12px;
        margin-bottom: 6px;
      }
    }
  }
`;
